function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".connect_svg__st3{fill:#7f63ff}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M530.5 38.5h139c6.1 0 11 4.9 11 11v101c0 6.1-4.9 11-11 11h-139c-6.1 0-11-4.9-11-11v-101c0-6.1 4.9-11 11-11z",
  fill: "none",
  stroke: "#7f63ff",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M633.7 82.7l-7.9-7.9-11.3 6.9v3.9l-20.9 20.9 2.2 2.2L617.7 87v-3.5l7.7-4.7 4.4 4.4-4.6 7.6-3.7-.2-21.9 21.9 2.2 2.2 4.5-4.5 7.5 7.5c.5.5 1.1.6 1.7.3 4-1.7 8.8-.9 12.1 2.4 2.6 2.6 3.6 6.1 3.1 9.4l-5.9-5.9c-.4-.4-1-.6-1.5-.4l-5.6 1.5c-.5.1-1 .6-1.1 1.1l-1.5 5.6c-.1.5 0 1.1.4 1.5l5.9 5.9c-3.3.5-6.9-.5-9.4-3.1-3.5-3.5-4.2-8.9-1.9-13.1l-2.3-2.3c-3.5 5.5-2.8 12.8 2 17.6 4.1 4.1 10.2 5.2 15.3 3.2.5-.2.9-.6 1-1.1.1-.5-.1-1.1-.4-1.4l-7.2-7.2 1-3.8 3.8-1 7.2 7.2c.4.4.9.5 1.4.4.5-.1 1-.5 1.1-1 2-5.1 1-11.1-3.2-15.3-3.9-3.9-9.6-5.1-14.6-3.4l-6.8-6.8 14.2-14.2 4.1.2 7-11.3zM590.1 103l-4.6 4.6c-.6.6-.6 1.6 0 2.2.6.6.6 1.6 0 2.2-.6.6-1.6.6-2.2 0-.6-.6-1.6-.6-2.2 0L570 123.1c-4.3 4.3-4.3 11.3 0 15.6 4.3 4.3 11.3 4.3 15.6 0l11.2-11.2c.6-.6.6-1.5.1-2.1-.5-.6-.5-1.5.1-2.1.6-.6 1.5-.6 2.1-.1.6.5 1.6.5 2.1-.1l4.7-4.7-2.2-2.2-3.8 3.8c-1.7-.7-3.7-.3-5.1 1-1.4 1.4-1.7 3.4-1 5.1l-10.3 10.3c-3.1 3.1-8.1 3.1-11.1 0-3.1-3.1-3.1-8.1 0-11.1l10.2-10.2c1.8.8 3.9.5 5.4-.9 1.5-1.5 1.8-3.6.9-5.4l3.7-3.7-2.5-2.1zm10.2-3.1l-6.8-6.8c1.7-4.9.5-10.6-3.4-14.6-4.1-4.1-10.2-5.2-15.3-3.2-.5.2-.9.6-1 1.1-.1.5.1 1.1.4 1.4l7.2 7.2-1 3.8-3.8 1-7.2-7.2c-.4-.4-.9-.5-1.4-.4-.5.1-1 .5-1.1 1-2 5.1-1 11.1 3.2 15.3 4.8 4.8 12.1 5.4 17.6 2l-2.3-2.3c-4.2 2.3-9.5 1.6-13.1-1.9-2.6-2.6-3.6-6.1-3.1-9.4l5.9 5.9c.4.4 1 .6 1.5.4l5.6-1.5c.5-.1 1-.6 1.1-1.1l1.5-5.6c.1-.5 0-1.1-.4-1.5l-5.9-5.9c3.3-.5 6.9.5 9.4 3.1 3.3 3.3 4.1 8.1 2.4 12.1-.3.6-.1 1.3.3 1.7l7.5 7.5 2.2-2.1z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7f63ff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M519.5 54h161",
  fill: "none",
  stroke: "#7f63ff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "connect_svg__st3",
  cx: 655.5,
  cy: 46.5,
  r: 2
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "connect_svg__st3",
  cx: 662.5,
  cy: 46.5,
  r: 2
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "connect_svg__st3",
  cx: 669.5,
  cy: 46.5,
  r: 2
});

function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "connect_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 200",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "95399e0e581e1fe976c8f51e63960df4.svg";
export { SvgConnect as ReactComponent };